/*
  Espressoshop: elementen glider mjukt in när de kommer in i bild (startsidan).
  Utan JS eller med "minska rörelse" syns allt direkt.
*/
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const GRUPPER = [
    // [element som glider in, förskjutning mellan syskon i ms]
    ['.es-tiles__heading', 0],
    ['.es-tiles__item', 70],
    ['.es-marken__kort', 0],
    ['main .section-resource-list__header', 0],
    ['main .resource-list__slide, main .resource-list__item', 80],
    ['footer .footer-content > *', 90],
  ];
  const io = new IntersectionObserver((poster) => {
    for (const p of poster) {
      if (!p.isIntersecting) continue;
      p.target.classList.add('is-synlig');
      io.unobserve(p.target);
    }
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  const start = () => {
    for (const [sel, steg] of GRUPPER) {
      const el = [...document.querySelectorAll(sel)];
      el.forEach((e) => {
        if (e.classList.contains('es-reveal')) return;
        // Förskjutningen räknas inom varje förälder, så att varje rad startar om
        const i = [...e.parentElement.children].filter((s) => s.matches(sel)).indexOf(e);
        e.style.setProperty('--es-reveal-delay', `${Math.min(i, 8) * steg}ms`);
        e.classList.add('es-reveal');
        io.observe(e);
      });
    }
  };
  document.documentElement.classList.add('es-reveal-pa');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
